import { cva } from '@/styled-system/css';

export const formHelpRecipe = cva({
  base: {
    display: 'flex',
    textStyle: 'body-xs',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    error: {
      true: {
        'color': 'FormField.HelperArea.text.error',
        '& > .c11n_icon': {
          marginInlineEnd: 'tightest',
          color: 'FormField.HelperArea.icon.error',
        },
      },
      false: {
        color: 'FormField.HelperArea.text.default',
      },
    },
  },
});
